require('./OKAccelerometerMonthlyChart.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { PieChart, Pie, Cell, ResponsiveContainer } = require('recharts');

// @constants
const {
    ACCELEROMETER_COLORS,
    ACCELEROMETER_COLOR_INDICATOR,
    ACCELEROMETER_COLOR_DOTS,
} = require('constants/charts'); //colors for component

class OKAccelerometerMonthlyChart extends React.Component {
    constructor(props) {
        super(props);

        this.buildDataPieChartDots = this.buildDataPieChartDots.bind(this);
        this.getAngle = this.getAngle.bind(this);
    }

    // Function to get the angle and the position for the needle
    getAngle() {
        const { monthlyValue } = this.props;
        const value =
            monthlyValue <= 0 ? 1 + monthlyValue * -1 : 1 - monthlyValue;
        let angleExpenses = 0;
        switch (value) {
            case 0:
                angleExpenses = 0;
                break;
            case 1:
                angleExpenses = 90;
                break;
            case 2:
                angleExpenses = 180;
                break;
            default:
                angleExpenses = 180 * (value / 2);
        }
        return angleExpenses;
    }

    // Function to draw dots
    buildDataPieChartDots() {
        let dataDots = [];
        for (let i = 0; i < 30; i++) {
            dataDots.push({
                name: `v-${i}`,
                value: 1,
            });
        }
        return dataDots;
    }

    render() {
        const data = [
            { name: 'Value1', value: 100 },
            { name: 'Value2', value: 100 },
            { name: 'Value3', value: 100 },
        ]; //False data to draw threw sections
        const ExpenseMonthly = [{ name: 'ExpenseMonthly', value: 300 }]; //False data to draw yellow indicator
        const angleNeedle = this.getAngle() * -1;
        return (
            <div className="ok-accelerometer-chart-container col-xs-12 col-md-12">
                <ResponsiveContainer width="100%" height={270}>
                    <PieChart>
                        <Pie
                            data={this.buildDataPieChartDots()}
                            isAnimationActive
                            stroke="none"
                            startAngle={180}
                            endAngle={0}
                            innerRadius={118}
                            outerRadius={120}
                            fill={ACCELEROMETER_COLOR_DOTS}
                            paddingAngle={5}
                        />
                        <Pie
                            data={ExpenseMonthly}
                            animationDuration={1000}
                            stroke="none"
                            startAngle={180}
                            isAnimationActive
                            endAngle={this.getAngle()}
                            innerRadius={115}
                            outerRadius={120}
                            fill={ACCELEROMETER_COLOR_INDICATOR}
                        />
                        <Pie
                            isAnimationActive
                            stroke="none"
                            data={data}
                            startAngle={180}
                            endAngle={0}
                            innerRadius={95}
                            outerRadius={110}
                        >
                            {data.map((entry, index) => (
                                <Cell
                                    key={index}
                                    fill={
                                        ACCELEROMETER_COLORS[
                                            index % ACCELEROMETER_COLORS.length
                                        ]
                                    }
                                />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
                <div className="ok-accelerometer-chart-container__needle">
                    <div className="ok-accelerometer-chart-container__needle-circle">
                        {}
                    </div>
                    <div
                        className="ok-accelerometer-chart-container__needle-triangle"
                        style={{ transform: `rotate(${angleNeedle}deg )` }}
                    >
                        {}
                    </div>
                </div>
            </div>
        );
    }
}

OKAccelerometerMonthlyChart.propTypes = {
    monthlyValue: PropTypes.number,
};

module.exports = OKAccelerometerMonthlyChart;
